import styles from './styles/form_label.module.scss';

export const FormLabel = ({ text, isRequired = false }) => {
  return (
    <span className={styles.form_label}>
      {text}
      {isRequired && <span className={styles.form_label_required}>*</span>}
    </span>
  );
};
